var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplied(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 20H3.33335C2.87335 20 2.50002 19.6275 2.50002 19.1667C2.50002 16.4092 4.74252 14.1667 7.50002 14.1667H12.5C15.2575 14.1667 17.5 16.4092 17.5 19.1667C17.5 19.6275 17.1267 20 16.6667 20ZM17.0834 5H16.6667C16.6667 3.16167 15.1717 1.66667 13.3334 1.66667H10.8334V0.833333C10.8334 0.3725 10.46 0 10 0C9.54002 0 9.16669 0.3725 9.16669 0.833333V1.66667H6.66669C4.82835 1.66667 3.33335 3.16167 3.33335 5H2.91669C2.22752 5 1.66669 5.56083 1.66669 6.25V7.91667C1.66669 8.60583 2.22752 9.16667 2.91669 9.16667H3.33335C3.33335 11.005 4.82835 12.5 6.66669 12.5H13.3334C15.1717 12.5 16.6667 11.005 16.6667 9.16667H17.0834C17.7725 9.16667 18.3334 8.60583 18.3334 7.91667V6.25C18.3334 5.56083 17.7725 5 17.0834 5ZM7.91669 8.33333C7.22669 8.33333 6.66669 7.77333 6.66669 7.08333C6.66669 6.39333 7.22669 5.83333 7.91669 5.83333C8.60669 5.83333 9.16669 6.39333 9.16669 7.08333C9.16669 7.77333 8.60669 8.33333 7.91669 8.33333ZM12.0834 8.33333C11.3934 8.33333 10.8334 7.77333 10.8334 7.08333C10.8334 6.39333 11.3934 5.83333 12.0834 5.83333C12.7734 5.83333 13.3334 6.39333 13.3334 7.08333C13.3334 7.77333 12.7734 8.33333 12.0834 8.33333Z",
    fill: "url(#paint0_linear_260_70)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_260_70",
    x1: 10,
    y1: 0,
    x2: 10,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#91C04A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009EDB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplied);
export default __webpack_public_path__ + "static/media/applied.f1054d9aad9bdacb74ea1f8781ea6e60.svg";
export { ForwardRef as ReactComponent };